"use strict";

var _slicedToArray = require("/opt/render/project/src/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.percentEncodeParams = void 0;

function isValidStringParam(param) {
  var _param = _slicedToArray(param, 2),
      value = _param[1];

  return typeof value === "string" && value.length > 0;
}

function paramToStringParam(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  return Array.isArray(value) ? [key, value.join(",")] : [key, value];
}

function percentEncodeParams(params) {
  return Object.entries(params).map(paramToStringParam).filter(isValidStringParam).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    return "".concat(key, "=").concat(encodeURIComponent(value));
  }).join("&");
}

exports.percentEncodeParams = percentEncodeParams;